module.exports = __webpack_public_path__ + "static/media/New_transaction_manually.5a37e166.png";